// PPS CRM - Cash Flow Module
import { useEffect, useState } from 'react';
import { api } from '../lib/api';

interface Transaction {
  id: string;
  amount: string;
  status: 'PENDING' | 'VERIFIED' | 'FAILED' | 'REFUNDED';
  transactionDate: string;
  client: { id: string; fullLegalName: string; packageType: string };
}

export default function CashFlow() {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      const response = await api.get('/api/cashflow');
      setTransactions(response.data);
    } catch (error) {
      console.error('Error fetching cashflow:', error);
    } finally {
      setLoading(false);
    }
  };

  const verifyTransaction = async (id: string) => {
    try {
      await api.post(`/api/cashflow/verify/${id}`, {
        confirmedAt: new Date().toISOString(),
      });
      fetchTransactions();
    } catch (error) {
      console.error('Error verifying transaction:', error);
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Cash Flow</h2>

      <div className="card overflow-hidden">
        {loading ? (
          <div className="p-8 text-center">Loading...</div>
        ) : transactions.length === 0 ? (
          <div className="p-8 text-center text-dark-gray">No pending transactions</div>
        ) : (
          <table className="w-full">
            <thead className="bg-light-gray">
              <tr>
                <th className="px-4 py-3 text-left">Client</th>
                <th className="px-4 py-3 text-left">Amount</th>
                <th className="px-4 py-3 text-left">Status</th>
                <th className="px-4 py-3 text-left">Date</th>
                <th className="px-4 py-3 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((t) => (
                <tr key={t.id} className="border-b border-light-gray hover:bg-light-gray">
                  <td className="px-4 py-3">{t.client.fullLegalName}</td>
                  <td className="px-4 py-3">${Number(t.amount).toFixed(2)}</td>
                  <td className="px-4 py-3">{t.status}</td>
                  <td className="px-4 py-3">{new Date(t.transactionDate).toLocaleDateString()}</td>
                  <td className="px-4 py-3">
                    {t.status === 'PENDING' && (
                      <button
                        onClick={() => verifyTransaction(t.id)}
                        className="text-primary hover:underline text-sm"
                      >
                        Verify
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
